<template>
  <div class="disease-item">
    <div class="title">{{ name }}</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
      <el-form-item label="症状" prop="symptoms">
        <el-checkbox-group v-model="form.symptoms">
          <el-checkbox
            :disabled="form.symptoms.length === maxSelectCount && !form.symptoms.includes(item.text)"
            :label="item.text"
            v-for="(item, i) in mergeSymptoms"
            @click.native="overSelectCountHint('symptoms', item.text)"
            :key="i"
            name="symptoms"
          />
          <el-autocomplete
            class="autocomplete"
            :disabled="form.symptoms.length === maxSelectCount || !drugId"
            v-model="searchSymptomTag"
            valueKey="text"
            :fetch-suggestions="(tag, cb) => queryTags(tag, cb, originSymptoms)"
            placeholder="请输入症状（带搜索）"
            @select="val => handleSelect(val, 'symptoms')"
            @click.native="overSelectCountHint('symptoms')"
            style="width: 300px"
          >
            <template #default="{ item }">
              <div class="custom-tag" v-if="item.type === 'custom'">
                <div class="left">自定义：{{ item.text }}</div>
                <div class="right">添加</div>
              </div>
              <div v-else>
                {{ item.text }}
              </div>
            </template>
          </el-autocomplete>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="诊断" prop="illnesses">
        <el-checkbox-group v-model="form.illnesses">
          <el-checkbox
            :disabled="form.illnesses.length === maxSelectCount && !form.illnesses.includes(item.text)"
            :label="item.text"
            v-for="(item, i) in mergeIllnesses"
            :key="i"
            @click.native="overSelectCountHint('illnesses', item.text)"
            name="illnesses"
          />
          <el-autocomplete
            class="autocomplete"
            :disabled="form.illnesses.length === maxSelectCount || !drugId"
            v-model="searchIllnessTag"
            valueKey="text"
            :fetch-suggestions="(tag, cb) => queryTags(tag, cb, originIllnesses)"
            placeholder="请输入诊断（带搜索）"
            @select="val => handleSelect(val, 'illnesses')"
            @click.native="overSelectCountHint('illnesses')"
            style="width: 300px"
          >
            <template #default="{ item }">
              <div class="custom-tag" v-if="item.type === 'custom'">
                <div class="left">自定义：{{ item.text }}</div>
                <div class="right">添加</div>
              </div>
              <div v-else>
                {{ item.text }}
              </div>
            </template>
          </el-autocomplete>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'diseaseBox',
  props: {
    name: {
      type: String
    },
    originSymptoms: {
      type: Array,
      default: () => []
    },
    originIllnesses: {
      type: Array,
      default: () => []
    },
    maxSelectCount: {
      type: Number,
      default: 3
    },
    drugId: {
      type: Number
    },
    // 是否允许自定义tag
    hasCustomTag: {
      type: Boolean
    }
  },
  data() {
    return {
      form: { symptoms: [], illnesses: [] },
      rules: {
        symptoms: [{ type: 'array', required: true, message: '症状不能为空', trigger: 'change' }],
        illnesses: [{ type: 'array', required: true, message: '诊断不能为空', trigger: 'change' }]
      },
      customSymptoms: [],
      customIllnesses: [],
      searchSymptomTag: '',
      searchIllnessTag: ''
    };
  },
  computed: {
    mergeSymptoms() {
      const { originSymptoms, customSymptoms } = this;
      return originSymptoms.filter((o, i) => i < 8).concat(customSymptoms);
    },
    mergeIllnesses() {
      const { originIllnesses, customIllnesses } = this;
      return originIllnesses.filter((o, i) => i < 8).concat(customIllnesses);
    }
  },
  watch: {
    // 重新选药时触发
    originSymptoms() {
      this.initForm();
    }
  },
  methods: {
    initForm() {
      this.searchSymptomTag = '';
      this.searchIllnessTag = '';
      this.customSymptoms = [];
      this.customIllnesses = [];
      this.$nextTick(() => {
        // 在input清空后，再重置表单，确保不出现表单校验样式
        this.$refs.form.resetFields();
      });
    },
    queryTags(tag, cb, tags) {
      let custom = null;

      if (tag?.length > 0) {
        if (this.hasCustomTag) {
          const hasTag = !!tags.find(o => o.text.toLowerCase() === tag.toLowerCase());
          if (!hasTag) {
            custom = { text: tag, type: 'custom' };
          }
        }

        const filterTags = tags.filter(o => o.text.toLowerCase().indexOf(tag.toLowerCase()) > -1);

        cb(custom ? [custom].concat(filterTags) : filterTags);
      } else {
        cb([]);
      }
    },
    handleSelect(item, type) {
      if (type === 'symptoms') {
        if (item.type === 'custom' || !this.mergeSymptoms.find(o => o.text === item.text)) {
          this.customSymptoms.push(item);
        }
        this.form.symptoms = this.form.symptoms.concat(item.text);
        this.searchSymptomTag = '';
      } else {
        if (item.type === 'custom' || !this.mergeIllnesses.find(o => o.text === item.text)) {
          this.customIllnesses.push(item);
        }
        this.form.illnesses = this.form.illnesses.concat(item.text);
        this.searchIllnessTag = '';
      }
    },
    overSelectCountHint(type, text) {
      const { form, maxSelectCount } = this;
      if (form[type].length === maxSelectCount) {
        if (!text) {
          const name = type === 'symptoms' ? '症状' : '诊断';
          this.$message.info(`最多选择3种${name}`);
        } else {
          if (!form[type].includes(text)) {
            const name = type === 'symptoms' ? '症状' : '诊断';
            this.$message.info(`最多选择3种${name}`);
          }
        }
      } else if (!this.drugId) {
        this.$message.error('请选择药品');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.disease-item {
  margin-bottom: 12px;

  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #707070;
  }

  /deep/.el-form-item__content {
    display: flex;
  }

  .autocomplete {
    margin-left: 32px;
  }
}

.custom-tag {
  display: flex;
  justify-content: space-between;

  .right {
    color: #1e8dff;
  }
}
</style>
